import React from 'react';

import {
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  X as XIcon,
} from '@mui/icons-material';

export const SocialMediaList = ({ title }) => {
  return (
    <ul>
      <h4 className="footer-header-row-title">{title}</h4>

      <div className="social-media-row">
        <a href="https://www.facebook.com/people/CashClever/61574125204930/" target="_blank">
          <FacebookIcon sx={{ fill: 'white' }} />
        </a>
        <a href="https://www.linkedin.com/company/cashclever-corp/" target="_blank">
          <LinkedInIcon sx={{ fill: 'white' }} />
        </a>
        <a href="https://x.com/CC_CoFounders/" target="_blank">
          <XIcon sx={{ fill: 'white' }} />
        </a>
      </div>
    </ul>
  );
};
